// Components==============
import indexFeedback from 'actions/feedback/index';
import indexNotification from 'actions/notification/index';
import indexProject from 'actions/project/index';
import indexTraining from 'actions/training/training/index';
import RecentActivity from 'components/UI/RecentActivity/RecentActivity';
import { motion } from 'framer-motion';
import { useOnClickOutside } from 'hooks/useOnClickOutside';
import { useTranslate } from 'hooks/useTranslate';
import React, { useContext, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { framerFade } from 'utilities/FramerAnimations';
import { GlobalRecentActivitiesContext } from 'utilities/GlobalContext/GlobalRecentActivities';
import './Messages.module.scss';
// =========================

export default function Messages({
  handleClose,
  messageRef,
}: {
  handleClose: () => void;
  messageRef: React.RefObject<HTMLDivElement>;
}) {
  const recentActivities = useContext(GlobalRecentActivitiesContext);

  const ref = useRef<HTMLDivElement>(null);

  useOnClickOutside({ refs: [ref, messageRef], handler: handleClose });

  const dispatch = useDispatch();
  const translate = useTranslate();

  useEffect(() => {
    dispatch(indexTraining());
    dispatch(indexProject());
    dispatch(indexFeedback());
    dispatch(indexNotification());
  }, []);

  return (
    <motion.div {...framerFade} ref={ref} styleName="wrapper">
      {!recentActivities.activities.length && (
        <div styleName="no-content">
          <img
            src="/images/error-illustrations/thinking-grey.svg"
            alt="no-content"
          />
          <h2>{translate('general.no-messages')}</h2>
          <p>{translate('general.no-messages-action')}</p>
        </div>
      )}
      {recentActivities.activities?.slice(0, 5).map((a, i) => (
        <RecentActivity activity={a} key={i} />
      ))}
    </motion.div>
  );
}
